import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    template: `<input pgsInputFilter type="text"  pgsInputFilter id="customInput" class="form-control form-control-sm w-50 mx-auto"
            [disabled]="rowData.disabled" [value]="this.rowData[this.customInput]" (input)="onChange($event.target.value)"
            [class.is-invalid]="hasError">`,
})
export class CustomInputCellComponent implements OnInit {

    constructor() { }

    customInput: string;
    errorInput: string;
    hasError = false;
    disabled = false;
    shouldFocus = true;
    quantity: any;

    map: (value: string) => any;
    errFn: (value: string) => boolean;

    @Input() rowData: any;
  /*eslint-disable */ @Output() change = new EventEmitter<any>(); /*eslint-enable */

    ngOnInit(): void {
        if (this.rowData[this.customInput] === undefined || this.rowData[this.customInput] === null) {
            this.rowData[this.customInput] = '';
        }
        if (this.rowData[this.errorInput] === undefined || this.rowData[this.errorInput] === null) {
            this.hasError = false;
        } else {
            this.hasError = this.rowData[this.errorInput];
        }
        if (this.shouldFocus) {
            document.getElementById('customInput').focus();
        }
    }

    onChange(ev: any): void {
        const response = this.map ? this.map(ev) : ev;
        this.hasError = this.errFn ? this.errFn(response) : false;
        this.rowData[this.customInput] = response;
        this.change.emit(this.rowData);
        // if (!isNaN(ev)) {
        //     this.hasError = false;
        //     this.rowData[this.errorInput] = false;

        // } else {
        //     this.hasError = true;
        //     this.rowData[this.errorInput] = true;
        // }

    }
}
